import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";
import { Button } from "@common";
import secureImg from "@illustrations/secure-564x400.png";

const InformationSafety = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const next = () => {
        helpers.navigateNext(location, navigate);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <div className="flex flex-col w-full">
            <h1 className="text-[20px] leading-[24px] md:text-[28px] md:leading-[40px] font-medium text-neutral-950 tracking-[0.2px] md:tracking-[0.28px] mb-8">
                You’re Safe with Sunbound
            </h1>

            <div className="flex justify-center mb-4">
                <img src={secureImg} alt="Illustration of a laptop with a lock displayed on its screen, representing information security offered on Sunbound's platform" className="w-[282px] h-[200px]" />
            </div>

            <div className="flex flex-col mb-8">
                <p className="text-base leading-6 font-medium text-neutral-950 tracking-[0.16px] mb-2">
                    Protecting your personal information is critically important.
                </p>
                <div className="flex flex-col gap-2">
                    <p className="text-sm leading-5 text-neutral-700 tracking-[0.14px]">
                        Sunbound uses industry-standard encryption to safeguard against potential threats.
                    </p>
                    <p className="text-sm leading-5 text-neutral-700 tracking-[0.14px]">
                        Your personal information is used only for what is absolutely necessary. We never sell data to a third party.
                    </p>
                    <p className="text-sm leading-5 text-neutral-700 tracking-[0.14px]">
                        See our <a className="text-blue-600 hover:text-blue-700 focus-visible:outline-focus-ring rounded" href="https://www.sunbound.ai/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a> for more information.
                    </p>
                </div>
            </div>

            <Button variant="primary" size="lg" className="w-full" onClick={next}>
                Continue
            </Button>
        </div>
    );
};

export default InformationSafety;
